import React from "react";
import { useTranslation } from "react-i18next";
import Layout from "../../components/layout";
import { SectionTitle, ChangelogTimeline } from "../../components/common";

const siteMetadata = {
  title: "Changelog - Designing Multi-Agent Systems",
  description:
    "What changed in each revision of Designing Multi-Agent Systems, and which revision is current.",
  author: "Victor Dibia",
  image: "/images/og-image.png",
  keywords: "changelog, book revisions, multi-agent systems, updates",
  twitterUsername: "@designingwithml",
};

// This URL is printed inside the book and cannot change. See dibia/RELEASING.md.
const ChangelogPage: React.FC = () => {
  const { t } = useTranslation("home");

  return (
    <Layout meta={siteMetadata} title="Changelog" link={"/changelog"}>
      <main>
        <div className="mb-6"></div>
        <SectionTitle title={t("changelogPage.title")}> </SectionTitle>

        <p className="text-secondary text-base leading-relaxed max-w-2xl mb-10">
          {t("changelogPage.intro")}
        </p>

        <ChangelogTimeline />

        <div className="mt-14 pt-6 border-t border-secondary">
          <p className="text-sm text-secondary leading-relaxed max-w-2xl">
            {t("changelogPage.digitalNote")}{" "}
            <a
              href="https://buy.multiagentbook.com"
              className="text-accent hover:underline"
            >
              buy.multiagentbook.com
            </a>
            .
          </p>
        </div>
      </main>
    </Layout>
  );
};

export default ChangelogPage;
